<template>
  <footer class="
    items-center
    flex
    flex-col
    justify-center
    m-4
    weiby-footer
  ">
    <img
      alt="Logo"
      class="h-[24px] mb-3 sm:h-[20px] sm:mb-2"
      src="/logo.svg"
    />
    <p class="sm:mb-1 sm:text-xs text-gray-500 text-sm">
      Copyright © {{ currentYear }} WeibyApps Co.,Ltd.  All rights reserved.
    </p>
    <p class="sm:text-xs text-gray-500 text-sm">
      Powered by
      <a alt="Weiby" class="no-decoration text-blue-400" href="https://weiby.tw/" target="_blank">
        WeibyApps
      </a>
    </p>
  </footer>
</template>

<script>
import Footer from './Footer';

export default Footer;
</script>

<style lang="scss" scoped>
@import 'Footer';
</style>
